'use client'

import { useMediaQuery } from '@segway/core'

import { Arrow } from '@/components/icons'
import { Link } from '@/i18n/navigation'

import styles from './moduleTitle.module.css'

const ModuleTitle = ({
  title = 'Title',
  viewAll = '/',
  linkText = 'View All',
  // pcLinkColor = '#DA291C',
}) => {
  const responsive = useMediaQuery()

  return (
    <div className="mb-[40px] flex w-full items-center justify-between max-xl:mb-[18px]">
      <div className="font-miSansDemiBold450 text-3xl text-black xl:text-6xl">{title}</div>
      {viewAll ? (
        <Link href={viewAll} className="flex gap-[6px] py-[8px] max-xl:gap-[2px] max-xl:py-[5px]">
          <div
            className={`${styles.learnmore} bg-size-[100%] flex items-center justify-center bg-primary font-miSansDemiBold450 text-[13px] text-[#000000] max-xl:leading-[16px] xl:text-lg xl:text-primary`}>
            {linkText}
          </div>
          <div className="flex items-center justify-center">
            <Arrow
              width={responsive && responsive.xl ? 20 : 16}
              height={responsive && responsive.xl ? 20 : 16}
              color={responsive && responsive.xl ? '#da291c' : '#000'}
            />
          </div>
        </Link>
      ) : null}
    </div>
  )
}

export default ModuleTitle
